import { useEffect } from 'react'
import { AppNotification } from '@digital-twins/shared-types'
import {
  onNotificationNew,
  disconnectNotificationsSocket,
  onArtifactAttentionChanged,
} from '@/lib/services/notifications-socket'

export function useNotificationsSocket(
  onNewNotification: (notification: AppNotification) => void,
  onAttentionChanged?: () => void,
) {
  useEffect(() => {
    const unsubscribe = onNotificationNew(onNewNotification)
    const unsubscribeAttention = onAttentionChanged
      ? onArtifactAttentionChanged(onAttentionChanged)
      : undefined

    return () => {
      unsubscribe()
      unsubscribeAttention?.()
      disconnectNotificationsSocket()
    }
  }, [onNewNotification, onAttentionChanged])
}
